import { createSlice, current } from '@reduxjs/toolkit';

const initialState = {
  fileList: null,
};

export const fileSlice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    setFile(state, action) {
      const file = action.payload;
      const currentState = current(state);
      const copyFileList = currentState.fileList ? [...currentState.fileList] : [];
      const fileIndex = copyFileList.findIndex((f) => f.name === file.name);
      if (fileIndex > -1) {
        copyFileList[fileIndex] = file;
      } else {
        copyFileList.push(file);
      }
      state.fileList = copyFileList;
    },
    setFileList(state, action) {
      state.fileList = action.payload;
    },
    cleanFilesSlice() {
      return initialState;
    },
  },
});

export const { cleanFilesSlice, setFile, setFileList } = fileSlice.actions;

export default fileSlice.reducer;
